import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import '../App.css';

export default class ImageUploader extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      scale: 1.0,
      rotation: 0,
      editorHeight: 240,
      modalHeight: 380,
      rootHeight: 380,
    };
  }

  handleUpload(event) {
    event.preventDefault();
    console.log('Handle file uplaod event...');
  }

  onClickSave(event) {
    console.log('Save button clicked...');
    event.preventDefault();
    if (this.editor) {
      // const canvas = this.editor.getImage();
      const canvasScaled = this.editor.getImageScaledToCanvas()
      let that = this;
      this.setState({imgFile: canvasScaled, binFile: canvasScaled}, function() {
        that.props.finish();
      }); 
    } else {
      console.log('Editor is not defined!');
    }   
  }

  setEditorRef = (editor) => this.editor = editor;

  resizeEditor(data) {
    // Set height from image that got dropped
    let height = Math.round(data.height);
    this.setState({editorHeight: height, modalHeight: height + 40, rootHeight: height});
  }

  handleFileChange(e) {
    console.log('HandleFileChange got fired!');
    e.preventDefault();
    this.setState({ file: e.target.files[0], imgFile: e.target.files[0], binFile: e.target.files[0] }, function () {
    });
  }

  rotateImage(event, dir) {
    event.preventDefault();
    let rotation = this.state.rotation || 0;
    if (dir === 'left') {
      rotation -= 90; 
    } else {
      rotation += 90; 
    }   
    this.setState({rotation: rotation});
  }

  render() {
    return (
      <div className='greyOverlay'>
        <div className='basicModal' style={{width: '500px', paddingRight: '6px', height: this.state.modalHeight + 'px'}}>
          <div style={{textAlign: 'left', marginBottom: '4px'}}>Upload Image<br /></div>
          <div style={{textAlign: 'left'}} height={this.state.rootHeight}>
            <AvatarEditor 
                 image={this.state.imgFile || "http://example.com/initialimage.jpg"}
                 ref={this.setEditorRef} 
                 onLoadSuccess={(info) => this.resizeEditor(info)}
                 width={492} height={this.state.editorHeight} border={2} color={[205, 215, 225, 0.6]} 
                 scale={this.state.scale} rotate={this.state.rotation} 
            />  
          </div>
          <input type="file" onChange={(e) => this.handleFileChange(e)} />

          <button onClick={(e) => this.rotateImage(e, 'left')}>&#8592;</button>
          <button onClick={(e) => this.rotateImage(e, 'right')}>&#8594;</button>

          <button className='smallCancelButton' onClick={() => this.props.finish()}>Cancel</button>&nbsp;
          <button className='smallSubmitButton' onClick={(e) => this.onClickSave(e)}>OK</button>
        </div>
      </div>
    );
  }
}
